export const GET_PAYMENT_HISTORY = 'GET_PAYMENT_HISTORY';
export const SEND_INVITE = 'SEND_INVITE';
export const GET_INVITED_USERS = 'GET_INVITED_USERS';
export const DELETE_INVITE = 'DELETE_INVITE';